export default "/assets/images/mila-room-showcase-sm-01.cd0bd6ce83cec7ef.webp";